import { render, staticRenderFns } from "./zhgddetail.vue?vue&type=template&id=f761875c&scoped=true&"
import script from "./zhgddetail.vue?vue&type=script&lang=js&"
export * from "./zhgddetail.vue?vue&type=script&lang=js&"
import style0 from "./zhgddetail.vue?vue&type=style&index=0&id=f761875c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f761875c",
  null
  
)

export default component.exports